import { jsx as _jsx } from "react/jsx-runtime";
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Small from 'UIComponents/elements/Small';
import { FlowManager } from '../flow-management/FlowManager';
import { setNextStep } from '../flow-management/setNextStep';
import { StyledUILink } from '../views-components/TextInput.styles';
import { Step } from '../views/Step';

const ResendCodeFooter = ({
  className
}) => {
  const stepKey = Step.CodeVerification;
  const dispatch = useDispatch();

  const goToResendEmailStep = () => {
    return dispatch(setNextStep({
      rebuilder: FlowManager.pushNextSteps(Step.ResendEmail)
    }));
  };

  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link: StyledUILink,
          strong: ({
            children
          }) => /*#__PURE__*/_jsx("strong", {
            children: children
          }),
          br: () => /*#__PURE__*/_jsx("br", {})
        },
        message: `views.${stepKey}.cantSeeEmail_jsx`,
        options: {
          onClick: goToResendEmailStep
        }
      })
    })
  });
};

ResendCodeFooter.propTypes = {
  className: PropTypes.string
};
export default ResendCodeFooter;